import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarJobTask } from 'src/app/public/car/models/car-job-task.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';
import { KeepBasicData } from 'src/app/public/keep/constants/keep-basic-data';


@Component({
    selector: 'app-carref-job-tasks',
    templateUrl: './carref-job-tasks.component.html',
    styleUrl: './carref-job-tasks.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefJobTasksComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() jobTasks: CarJobTask[] = [];

  newItem: CarJobTask = new CarJobTask('', '');
  editedItem: CarJobTask = new CarJobTask('', '');

  displayedColumns: string[] = ['id', 'code', 'title', 'category', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarJobTask>(this.jobTasks);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  jobCategories = KeepBasicData.carJobCategories;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.jobTasksFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['jobTasks']){
      this.dataSource.data = changes['jobTasks'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarJobTask('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarJobTask('','');
      this.dataSource.data = [...this.dataSource.data, new CarJobTask('','')];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.jobTasks.find((manuf: CarJobTask) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.jobTasks.find((item: CarJobTask) => item.id === id) );
    //console.log(this.editedItem);
  }

  SaveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.jobTasks.find((manuf: CarJobTask) => manuf.id === id));
    this.editedItem = Object.assign({}, this.jobTasks.find((manuf: CarJobTask) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.jobTaskNewSubmit({jobTask: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.jobTaskUpdateSubmit({jobTask: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.jobTaskDeleteSubmit({jobTaskId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.title.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
